module.exports = __webpack_public_path__ + "img/goldregen-2020-056.7fb65cb7.jpg";